import type { FieldDetailsContentProps } from './field-details-content.component';
import { FieldDetailsContent } from './field-details-content.component';
import { Container } from './field-details-card.styles';

export type FieldDetailsCardProps = FieldDetailsContentProps;

const FieldDetailsCard = (props: FieldDetailsCardProps) => (
  <Container>
    <FieldDetailsContent {...props} />
  </Container>
);

export default FieldDetailsCard;
